'use client'; // 声明为客户端组件
import React, {ReactNode, useEffect} from 'react';
import {useRouter} from 'next/navigation';
import {StartManager} from "@/Core/StartManager";
import RouterMgr from "@/Core/RouterMgr";
import {useUserDispatch} from "@/app/context/UserContext";
import UserMgr from "@/Core/UserMgr";
import MainScene from "@/Core/MainScene";
import DBMgr from "@/Core/DBMgr";
import RequestMgr from "@/Fwk/Http/RequestMgr";
import KitAPI from "@/Fwk/Kit/KitAPI";
import domain1 from '@/app/config/domain/domain_1';
import domain2 from '@/app/config/domain/5252slot';
import KitPwa from "@/Master/PWA/KitPwa";
import SPlayer from "@/Master/SPlayer";
import Util from "@/Master/Util";
import GameMgr from "@/app/(game)/GameMgr";
import WindowGlobal from "@/app/WindowGlobal";
import {UpdateMainState} from "@/app/MainSliceUtil";
import TestBtnEnter from "@/app/(test)/components/TestBtnEnter/TestBtnEnter";
import AiHelpBox from "@/Core/AIHelp/AiHelpBox";

interface MainProps {
    children?: ReactNode;
}

export default function Main({ children }: MainProps) {
    const router = useRouter();
    const userDispatch = useUserDispatch();

    // 模拟 constructor：在首次渲染时调用SPlayer.checkInit()
    // 由于函数组件没有constructor，这里使用useEffect并在依赖数组中留空，
    useEffect(() => {
        if (Util.isLog){
            console.log('[Main] 初始化数据在这里');
        }

        WindowGlobal.Init();
        RequestMgr.Init()
        RouterMgr.Init(router)
        UserMgr.Init(userDispatch);

        //初始化数据库
        DBMgr.Init(()=>{
            UpdateMainState('UpdateIsDB',{isDBok:true});

            if (GameMgr.checkGamePath){//是游戏页面内容 不进行登陆信息和初始化
                return;
            }
            SPlayer.checkInit();

            KitPwa.Init();

            //初始化SDK
            KitAPI.Init(JSON.stringify(domain2), JSON.stringify(domain1), false, false, false);

            KitAPI.IsSDKReady();

            StartManager.onInit();

            MainScene.onEnter();

        });

        // 进入游戏前判断本地缓存(localStorage或Cookie)中是否有登录数据。如果无数据则展示欢迎界面
        return () => {
            if (Util.isLog){
                console.log('[Main] 组件卸载前清理资源');
            }


            // 在这里清理事件监听、计时器、socket等
        };
    }, []);


    return <>
    <div className={`Main`}>
        {children}
        <AiHelpBox/>
        {/*{Util.isLog && Util.isTestMode && <TestBtnEnter/>}*/}
        {Util.isLog && Util.isTestMode && <TestBtnEnter/>}
    </div>
    </>;
}


